import * as Yup from 'yup';

import {
  name,
  nameKana,
  birthDate,
  gender,
  genderExpression,
  password,
  passwordConfirmation,
  username,
  optionalEmail,
} from '../common/attributes';

const schoolLearnerFormSchemaGenerator = (
  organizationMembershipCode?: string,
) => {
  return () => {
    return Yup.object().shape({
      school_learner: Yup.object().shape({
        last_name: name('last_name'),
        first_name: name('first_name'),
        last_name_kana: nameKana('last_name_kana', 30),
        first_name_kana: nameKana('first_name_kana', 30),
        birth_year: birthDate('birth_year'),
        birth_month: birthDate('birth_month'),
        birth_day: birthDate('birth_day'),
        gender: gender('gender'),
        gender_expression: genderExpression('gender_expression'),
        username: username('username', organizationMembershipCode),
        password: password('password', 'password_confirmation', 'username'),
        password_confirmation: passwordConfirmation('password_confirmation'),
        email: optionalEmail('email'),
      }),
    });
  };
};

export default schoolLearnerFormSchemaGenerator;
